import { call, put } from 'redux-saga/effects';
import { api, subscriptionTypes } from 'rp-auth';
import {
  loadUserServicesRequest,
  loadUserServicesSuccess,
  loadUserServicesFailure,
} from '../actions/userServices';

const { ESSENTIAL, INSIGHTS } = subscriptionTypes;

const { getUserServices, getApplicableToMove } = api;

export default function* (accountReference, session) {
  try {
    if (!session) {
      return null;
    }

    yield put(loadUserServicesRequest());
    const data = yield call(getUserServices, accountReference, session);

    if (!data) {
      yield put(loadUserServicesSuccess({ subscriptions: [] }));
      return { subscriptions: [] };
    }
    const { subscriptions } = data;

    const currentSubscription = subscriptions.find(service =>
      service.accountSubscriptionInfo.recurringPaymentInfo.statusInfo
        .statusDescription === 'Active');

    if (currentSubscription) {
      try {
        const { subscriptionsInfo } = yield call(
          getApplicableToMove,
          accountReference,
          session,
          currentSubscription.accountSubscriptionInfo.recurringPaymentInfo
            .resourceReference,
        );

        const services = global.__PRELOADED_STATE__.services;
        const upgradeToString =
                    currentSubscription.defaultSubscriptionInfo.customParameters.UpgradeTo;
        const servicesToUpgrade = subscriptionsInfo
          .filter(subscription =>
            upgradeToString &&
                            upgradeToString.indexOf(subscription.subscriptionId) > -1)
          .map((subscription) => {
            const {
              subscriptionId,
              subscriptionTitle,
              pricingInfo,
              contractInfo: { contractUnit },
            } = subscription;

            return {
              id: Number(subscriptionId),
              title: subscriptionTitle.replace(ESSENTIAL, INSIGHTS),
              price: pricingInfo[0].renewalPrice,
              periodUnit: contractUnit,
              features: services.find(service => service.id === Number(subscriptionId)).features,
              priceId: pricingInfo[0].resourceReference,
            };
          });

        currentSubscription.upgradeTo = servicesToUpgrade || [];
      } catch (error) {
        currentSubscription.upgradeTo = [];
      }
    }

    yield put(loadUserServicesSuccess({
      subscriptions,
    }));
    return {
      subscriptions,
    };
  } catch (error) {
    yield put(loadUserServicesFailure(error));
    return null;
  }
}
